import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo } from 'react';
import { ConnectionProvider, useConnection, useWallet, WalletProvider, } from '@solana/wallet-adapter-react';
import { UnsafeBurnerWalletAdapter } from '@solana/wallet-adapter-unsafe-burner';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initProgramInstance } from '../chains/svm/api';
import { getSolanaRpcList } from './chains';
import { MultichainWalletSwitcher } from './MultichainWalletSwitcher';
import { EVMWalletProvider } from './EVMWalletProvider';
import { createWagmiConfig } from './create-wagmi-config';
import { getWagmiChains } from './wagmi-chains';
function SolanaProgramInit({ autoInit, onReady }) {
    const { connection } = useConnection();
    const wallet = useWallet();
    useEffect(() => {
        if (!autoInit || !connection || !wallet.publicKey)
            return;
        initProgramInstance(connection, wallet);
        onReady?.();
    }, [autoInit, connection, wallet, wallet.publicKey, onReady]);
    return null;
}
export function MultichainWalletProvider({ children, appName, projectId, solanaWalletMode = 'browser', solanaRpc, autoInitSolanaProgram = false, onSolanaProgramReady, }) {
    const queryClient = useMemo(() => new QueryClient(), []);
    const wagmiConfig = useMemo(() => createWagmiConfig(appName, projectId), [appName, projectId]);
    const endpoint = solanaRpc ?? getSolanaRpcList()[0];
    const wallets = useMemo(() => {
        if (solanaWalletMode === 'burner') {
            return [new UnsafeBurnerWalletAdapter()];
        }
        // Empty list: Standard Wallet auto-discovery (Phantom/Solflare/etc.) — no legacy adapters.
        return [];
    }, [solanaWalletMode]);
    const wagmiChains = useMemo(() => getWagmiChains(), []);
    return (_jsx(MultichainWalletSwitcher, { children: _jsx(ConnectionProvider, { endpoint: endpoint, children: _jsx(WalletProvider, { wallets: wallets, autoConnect: solanaWalletMode === 'burner', children: _jsx(WagmiProvider, { config: wagmiConfig, children: _jsx(QueryClientProvider, { client: queryClient, children: _jsxs(EVMWalletProvider, { chains: wagmiChains, children: [_jsx(SolanaProgramInit, { autoInit: autoInitSolanaProgram, onReady: onSolanaProgramReady }), children] }) }) }) }) }) }));
}
/** @deprecated Use MultichainWalletProvider */
export const MyWalletProvider = MultichainWalletProvider;
